import { atom } from 'jotai';

import { loadUpdateAtom } from '../_graphql/mutationLoadUpdate';

import { createAutoSaveFormAtoms } from './createAutoSaveFormAtoms.state';
import { $outboundLoads, $outboundTicketDetail } from './scaleTicketPro.state';

export type OutboundDetailsFormState = {
  description: string | null;
  truckNumber: string | null;
  trailerNumber: string | null;
  driverName: string | null;
  containerNumber: string | null;
  sealNumber: string | null;
  bolNumber: string | null;
  deliveryNumber: string | null;
  releaseNumber: string | null;
};

export const DEFAULT_OUTBOUND_DETAILS_FORM: OutboundDetailsFormState = {
  description: null,
  truckNumber: null,
  trailerNumber: null,
  driverName: null,
  containerNumber: null,
  sealNumber: null,
  bolNumber: null,
  deliveryNumber: null,
  releaseNumber: null,
};

type OutboundDetailsServerData = {
  description: string | null;
  truckNumber: string | null;
  trailerNumber: string | null;
  driverName: string | null;
  containerNumber: string | null;
  sealNumber: string | null;
  bolNumber: string | null;
  deliveryNumber: string | null;
  releaseNumber: string | null;
};

const atoms = createAutoSaveFormAtoms<
  OutboundDetailsFormState,
  OutboundDetailsServerData
>({
  defaultForm: DEFAULT_OUTBOUND_DETAILS_FORM,
  fromServerData: (load) => ({
    description: load.description,
    truckNumber: load.truckNumber,
    trailerNumber: load.trailerNumber,
    driverName: load.driverName,
    containerNumber: load.containerNumber,
    sealNumber: load.sealNumber,
    bolNumber: load.bolNumber,
    deliveryNumber: load.deliveryNumber,
    releaseNumber: load.releaseNumber,
  }),
  createMutation: (onSuccess, onError) => {
    const $mut = loadUpdateAtom({
      onSuccess: (get, set, { params }) => onSuccess(get, set, params.id),
      onError: (get, set, { params }) => onError(get, set, params.id),
    });
    return atom(
      null,
      (
        _get,
        set,
        params: { ticketId: string; form: OutboundDetailsFormState },
      ) => {
        set($mut, {
          id: params.ticketId,
          description: params.form.description ?? undefined,
          truckNumber: params.form.truckNumber ?? undefined,
          trailerNumber: params.form.trailerNumber ?? undefined,
          driverName: params.form.driverName ?? undefined,
          containerNumber: params.form.containerNumber ?? undefined,
          sealNumber: params.form.sealNumber ?? undefined,
          bolNumber: params.form.bolNumber ?? undefined,
          deliveryNumber: params.form.deliveryNumber ?? undefined,
          releaseNumber: params.form.releaseNumber ?? undefined,
        });
      },
    );
  },
  refetchOnSuccess: (get) => {
    get($outboundTicketDetail).refetch();
    get($outboundLoads).refetch();
  },
});

export const $outboundDetailsFormById = atoms.$formById;
export const $outboundDetailsBaselineById = atoms.$baselineById;
export const $updateOutboundDetailsField = atoms.$updateField;
export const $syncOutboundDetailsForm = atoms.$syncForm;
export const $flushOutboundDetailsAutoSave = atoms.$flushAutoSave;
export const $cancelOutboundDetailsAutoSave = atoms.$cancelAutoSave;
export const $cleanupOutboundDetailsForm = atoms.$cleanupForm;
